angular.module 'zc.core'

.factory 'lib', ($filter, $location, Project) ->
  # https://github.com/monmo/monmo/blob/master/lib/utils.js#L190
  # lib.getField({hoge: {fuga: {piyo: 777}}}, "hoge.fuga.piyo") => 777
  getField: (data, field) ->
    return data unless field
    get = (d, f) ->
      k = f.shift()
      c = d[k]
      return c unless f.length
      get c, f
    get data, field.split('\.')

  stringToArray: (string, separator = ',') ->
    return string if _.isArray(string)
    return [] if _.isString(string) && string.length == 0

    try
      return string.split(separator)
    catch error
      return []

  setHighChartOptions: () ->
    Highcharts.setOptions
      global:
        useUTC: true
        getTimezoneOffset: (timestamp) ->
          return 0 unless timestamp

          localDate = $filter('changeDatetimeFrom')('regionToLocal', timestamp, 'moment')
          regionDate = moment.tz(localDate.format(), Project.getRegion())

          localUtcOffset = -localDate.utcOffset()
          regionUtcOffset = regionDate.utcOffset()
          isMidnight = moment(timestamp).format('HH:mm') == '00:00'
          if regionDate.isDST() && regionUtcOffset == 60 && !isMidnight
            localUtcOffset -= regionUtcOffset

          return localUtcOffset
      lang:
        months: moment.monthsShort()

  copyName: (oldName) ->
    newName = ""
    match = oldName.match(/\s\((\d+)\)$/)
    if match
      number = parseInt(match[1])
      newName = oldName.replace(match[0], " (#{number+1})")
    else
      newName = "#{oldName} (2)"
    return newName

  truncateFraction: (number) ->
   if number > 0
     Math.floor(number)
   else
     Math.ceil(number)

  removeFromLocationSearch: (itemName) ->
    oldSearch = $location.search()
    delete oldSearch[itemName]
    $location.search(oldSearch)

  iterateCountMaps: (countMaps, baseMap, accumulatedCountMaps) ->
    keyMap = {}
    for countMap in countMaps
      for key, val of countMap
        if _.isNumber(val)
          baseMap[key] ||= 0
          baseMap[key] += val
        else if _.isDate(val) or _.isString(val) or _.isBoolean(val)
          baseMap[key] = val
        else if _.isArray(val)
          throw 'Array is not supported!'
        else if _.isObject(val)
          baseMap[key] ||= {}
          keyMap[key] = true
      accumulatedCountMaps.push _.cloneDeep(baseMap) if accumulatedCountMaps
    keyMap

  sumCountMap: (countMaps, baseMap = {})->
    keyMap = @iterateCountMaps(countMaps, baseMap)
    for key in Object.keys(keyMap)
      vals = _.map(countMaps, key)
      @sumCountMap(vals, baseMap[key])
    baseMap

  accumulateCountMap: (countMaps, baseMap = {})->
    accumulatedCountMaps = []
    keyMap = @iterateCountMaps(countMaps, baseMap, accumulatedCountMaps)
    for key in Object.keys(keyMap)
      vals = _.map(countMaps, key)
      vals = @accumulateCountMap(vals, baseMap[key])
      accumulatedCountMaps.forEach (map, i) -> map[key] = vals[i]
    accumulatedCountMaps

  sumOriginalConversions: (stats) ->
    flattenedConversions = _.flatten(stats.original_conversions)
    _.reduce(flattenedConversions, (sumHourlyOriginalConversions, conversion) ->
      conversionPriceDecimal = new Decimal(conversion.price_decimal.$numberDecimal.toString())
      originalConversion = _.find(sumHourlyOriginalConversions, { currency: conversion.currency })
      if originalConversion
        originalConversion.price += conversion.price;
        originalConversion.price_decimal = originalConversion.price_decimal.plus(conversionPriceDecimal)
      else
        sumHourlyOriginalConversions.push({
          price: conversion.price,
          price_decimal: conversionPriceDecimal,
          currency: conversion.currency,
        })

      return sumHourlyOriginalConversions;
    , []);



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/lib.coffee